if (!customElements.get('tiered-rewards')) {
  const AMOUNT_PLACEHOLDER = '||amount||';
  const TIER_PLACEHOLDER = '||tier||';

  class TieredRewards extends HTMLElement {
    constructor() {
      super();

      this.requestId = 0;
      this.onCartUpdated = this.onCartUpdated.bind(this);
    }

    connectedCallback() {
      this.messageTemplate = this.dataset.messageTemplate || '';
      this.completeMessage = this.dataset.completeMessage || '';
      this.message = this.querySelector('[data-tiered-rewards-message]');

      const rate = Number(window.Shopify?.currency?.rate) || 1;

      this.tiers = Array.from(this.querySelectorAll('[data-tier]')).map((element) => ({
        element,
        name: element.dataset.tierName || '',
        threshold: Math.round(Number(element.dataset.threshold) * rate),
        fill: element.querySelector('[data-tier-fill]'),
        status: element.querySelector('[data-tier-status]'),
      }));

      document.addEventListener('theme:cart:added', this.onCartUpdated);

      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cart:added', this.onCartUpdated);
    }

    onCartUpdated() {
      this.update();
    }

    async update() {
      const requestId = ++this.requestId;

      try {
        const response = await fetch(`${window.theme.routes.cart_url}.js`, {
          headers: {Accept: 'application/json'},
        });

        if (!response.ok) {
          throw new Error(`Tiered rewards: failed to fetch cart (${response.status})`);
        }

        const cart = await response.json();

        if (requestId !== this.requestId) return;

        this.render(cart.total_price);
      } catch (error) {
        console.error(error);
      }
    }

    render(total) {
      let previousThreshold = 0;
      let nextTier = null;

      this.tiers.forEach((tier) => {
        const range = Math.max(tier.threshold - previousThreshold, 1);
        const progress = Math.min(Math.max((total - previousThreshold) / range, 0), 1) * 100;
        const isReached = total >= tier.threshold;

        tier.fill?.style.setProperty('--tier-progress', `${progress}%`);
        tier.element.classList.toggle('is-reached', isReached);

        if (tier.status) {
          tier.status.hidden = !isReached;
        }

        if (!isReached && !nextTier) {
          nextTier = tier;
        }

        previousThreshold = tier.threshold;
      });

      if (!this.message) return;

      if (!nextTier) {
        this.message.textContent = this.completeMessage;
        return;
      }

      this.message.innerHTML = this.messageTemplate
        .replace(AMOUNT_PLACEHOLDER, () => this.escapeHtml(this.formatMoney(nextTier.threshold - total)))
        .replace(TIER_PLACEHOLDER, () => this.escapeHtml(nextTier.name));
    }

    formatMoney(cents) {
      let formatted = typeof window.theme?.formatMoney === 'function' ? window.theme.formatMoney(cents, window.theme.moneyFormat) : (cents / 100).toFixed(2);

      if (formatted.endsWith('.00') || formatted.endsWith(',00')) {
        formatted = formatted.slice(0, -3);
      }

      if (window.theme?.settings?.currency_code_enable) {
        formatted += ` ${window.theme.current_iso_code}`;
      }

      return formatted;
    }

    escapeHtml(value) {
      const element = document.createElement('span');
      element.textContent = value;
      return element.innerHTML;
    }
  }

  customElements.define('tiered-rewards', TieredRewards);
}
